// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.parts_add_textfieldcontsiners {
  height: auto;
  width: 100%;
}
.parts_add_textfieldcontsiners .input-wrapper {
  position: relative;
}
.parts_add_textfieldcontsiners .partlistdropdowndiv_file-addparts {
  width: 32.9% !important;
}
.parts_add_textfieldcontsiners .required::after {
  content: " *";
  color: red;
}
.parts_add_textfieldcontsiners .input_parts_orders {
  border: 1px solid gray;
  border-radius: 6px;
  position: relative;
  width: 100%;
  height: 3rem;
  margin: 10px;
  line-height: 6ex;
}
.parts_add_textfieldcontsiners .selectpartsaddtextfields {
  border: 1px solid gray !important;
  border-radius: 6px !important;
  position: relative !important;
  margin: 10px !important;
  line-height: 6ex !important;
  width: 100% !important;
  height: 3rem !important;
}
.parts_add_textfieldcontsiners .selectpartsaddtextfield_category {
  border: 1px solid gray !important;
  border-radius: 6px !important;
  position: relative !important;
  margin: 10px !important;
  line-height: 6ex !important;
  width: 18.5rem !important;
  height: 3rem !important;
}
.parts_add_textfieldcontsiners label {
  position: absolute;
  top: 0.2ex;
  z-index: 1;
  left: 2em;
  background-color: white;
  padding: 0 5px;
  font-family: "Nunito";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  color: #0c3688;
}
.parts_add_textfieldcontsiners .select-wrapper {
  position: relative;
  display: block;
}
.parts_add_textfieldcontsiners .input::placeholder {
  font-family: "Nunito";
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  color: #10132e;
}
.parts_add_textfieldcontsiners select {
  border: 1px solid gray;
  border-radius: 6px;
  position: relative;
  margin: 10px;
  line-height: 6ex;
  width: 94%;
  height: 2.5rem;
}
.parts_add_textfieldcontsiners .select-vehicle-input {
  top: -3rem;
  position: inherit;
  z-index: 1;
  left: 12em;
  background-color: white;
  padding: 0 5px;
  font-family: "Nunito";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  color: #0c3688;
}
.parts_add_textfieldcontsiners .selectfile-file {
  border: 1px solid gray;
  border-radius: 6px;
  position: relative;
  width: 92%;
  height: 3rem;
  margin: 10px;
  line-height: 6ex;
  font-family: "Nunito";
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  color: #10132e;
  padding: 0rem 0.5rem;
}
.parts_add_textfieldcontsiners .parts_add_group_textfields {
  display: flex;
  align-items: center;
  gap: 5%;
  width: 96%;
  background: #ffffff;
  border-radius: 6px;
  background: #ffffff;
  border-radius: 6px;
  padding: 0.6rem;
  flex-wrap: wrap;
}
.parts_add_textfieldcontsiners .parts_add_textfields {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 20px;
  width: 96%;
  background: #ffffff;
  border-radius: 6px;
  background: #ffffff;
  border-radius: 6px;
  padding: 0.6rem;
  flex-wrap: wrap;
}
.parts_add_textfieldcontsiners .SubmitAddparts:disabled,
.parts_add_textfieldcontsiners .SubmitAddparts:disabled:hover {
  box-shadow: 0px 12px 20px 0px rgba(42, 59, 137, 0.3019607843);
  font-family: Nunito;
  font-size: 20px;
  font-weight: 700;
  margin: 1rem;
  padding: 0rem 3rem;
  border-radius: 8px;
  width: 14%;
  height: 2.4rem;
  color: white;
  background: #c0cdee !important;
}
.parts_add_textfieldcontsiners .SubmitAddparts {
  box-shadow: 0px 12px 20px 0px rgba(42, 59, 137, 0.3019607843);
  font-family: Nunito;
  font-size: 20px;
  padding: 0rem 3rem;
  font-weight: 700;
  background: #0C3688;
  color: #ffffff;
  margin: 1rem;
  border-radius: 8px;
  width: fit-content !important;
  height: 2.4rem;
}
.parts_add_textfieldcontsiners .parts_add_textfieldcontsiners .SubmitAddparts {
  box-shadow: 0px 12px 20px 0px rgba(42, 59, 137, 0.3019607843);
  font-family: Nunito;
  font-size: 20px;
  font-weight: 700;
  background: #0C3688;
  color: #ffffff;
  margin: 1rem;
  border-radius: 8px;
  width: 14%;
  height: 2.4rem;
}

.part_label {
  top: -7px !important;
  left: 15px !important;
}

.multiselect_part {
  margin-left: 10px !important;
  width: 100% !important;
}

.multiselect_part fieldset {
  border: 1px solid #a3aec4;
  border-radius: 6px;
}

.multipleSelect_part {
  height: 50px;
  width: 100% !important;
}

.multiselect_input {
  min-width: 80% !important;
}

@media screen and (max-width: 480px) {
  .parts_add_textfieldcontsiners .partlistdropdowndiv_file-addparts {
    width: 81% !important;
  }
  label {
    z-index: 1 !important;
  }
  .SubmitAddparts {
    margin-bottom: 20rem !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/component/PartsAdd_s/partsaddtextfields.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,WAAA;AACF;AACE;EACE,kBAAA;AACJ;AAEE;EACE,uBAAA;AAAJ;AAGE;EACE,aAAA;EACA,UAAA;AADJ;AAIE;EACE,sBAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,gBAAA;AAFJ;AAKE;EACE,iCAAA;EACA,6BAAA;EACA,6BAAA;EACA,uBAAA;EACA,2BAAA;EACA,sBAAA;EACA,uBAAA;AAHJ;AAME;EACE,iCAAA;EACA,6BAAA;EACA,6BAAA;EACA,uBAAA;EACA,2BAAA;EACA,yBAAA;EACA,uBAAA;AAJJ;AAOE;EACE,kBAAA;EACA,UAAA;EACA,UAAA;EACA,SAAA;EACA,uBAAA;EACA,cAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AALJ;AAQE;EACE,kBAAA;EACA,cAAA;AANJ;AASE;EACE,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AAPJ;AAUE;EACE,sBAAA;EACA,kBAAA;EACA,kBAAA;EACA,YAAA;EACA,gBAAA;EACA,UAAA;EACA,cAAA;AARJ;AAWE;EACE,UAAA;EACA,iBAAA;EACA,UAAA;EACA,UAAA;EACA,uBAAA;EACA,cAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AATJ;AAYE;EACE,sBAAA;EACA,kBAAA;EACA,kBAAA;EACA,UAAA;EACA,YAAA;EACA,YAAA;EACA,gBAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,oBAAA;AAVJ;AAaE;EACE,aAAA;EACA,mBAAA;EACA,OAAA;EACA,UAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;AAXJ;AAcE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,SAAA;EACA,UAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;AAZJ;AAeE;;EAEE,6DAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,UAAA;EACA,cAAA;EACA,YAAA;EACA,8BAAA;AAbJ;AAgBE;EACE,6DAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;EACA,YAAA;EACA,kBAAA;EACA,6BAAA;EACA,cAAA;AAdJ;AAiBE;EACE,6DAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;EACA,cAAA;AAfJ;;AAmBA;EACE,oBAAA;EACA,qBAAA;AAhBF;;AAmBA;EACE,4BAAA;EACA,sBAAA;AAhBF;;AAmBA;EACE,yBAAA;EACA,kBAAA;AAhBF;;AAmBA;EACE,YAAA;EACA,sBAAA;AAhBF;;AAmBA;EACE,yBAAA;AAhBF;;AAmBA;EACE;IACE,qBAAA;EAhBF;EAmBA;IACE,qBAAA;EAjBF;EAoBA;IACE,+BAAA;EAlBF;AACF","sourcesContent":[".parts_add_textfieldcontsiners {\n  height: auto;\n  width: 100%;\n\n  .input-wrapper {\n    position: relative;\n  }\n\n  .partlistdropdowndiv_file-addparts {\n    width: 32.9% !important;\n  }\n\n  .required::after {\n    content: ' *';\n    color: red;\n  }\n\n  .input_parts_orders {\n    border: 1px solid gray;\n    border-radius: 6px;\n    position: relative;\n    width: 100%;\n    height: 3rem;\n    margin: 10px;\n    line-height: 6ex;\n  }\n\n  .selectpartsaddtextfields {\n    border: 1px solid gray !important;\n    border-radius: 6px !important;\n    position: relative !important;\n    margin: 10px !important;\n    line-height: 6ex !important;\n    width: 100% !important;\n    height: 3rem !important;\n  }\n\n  .selectpartsaddtextfield_category {\n    border: 1px solid gray !important;\n    border-radius: 6px !important;\n    position: relative !important;\n    margin: 10px !important;\n    line-height: 6ex !important;\n    width: 18.5rem !important;\n    height: 3rem !important;\n  }\n\n  label {\n    position: absolute;\n    top: 0.2ex;\n    z-index: 1;\n    left: 2em;\n    background-color: white;\n    padding: 0 5px;\n    font-family: \"Nunito\";\n    font-style: normal;\n    font-weight: 400;\n    font-size: 14px;\n    color: #0c3688;\n  }\n\n  .select-wrapper {\n    position: relative;\n    display: block;\n  }\n\n  .input::placeholder {\n    font-family: \"Nunito\";\n    font-style: normal;\n    font-weight: 600;\n    font-size: 16px;\n    color: #10132e;\n  }\n\n  select {\n    border: 1px solid gray;\n    border-radius: 6px;\n    position: relative;\n    margin: 10px;\n    line-height: 6ex;\n    width: 94%;\n    height: 2.5rem;\n  }\n\n  .select-vehicle-input {\n    top: -3rem;\n    position: inherit;\n    z-index: 1;\n    left: 12em;\n    background-color: white;\n    padding: 0 5px;\n    font-family: \"Nunito\";\n    font-style: normal;\n    font-weight: 400;\n    font-size: 14px;\n    color: #0c3688;\n  }\n\n  .selectfile-file {\n    border: 1px solid gray;\n    border-radius: 6px;\n    position: relative;\n    width: 92%;\n    height: 3rem;\n    margin: 10px;\n    line-height: 6ex;\n    font-family: \"Nunito\";\n    font-style: normal;\n    font-weight: 600;\n    font-size: 16px;\n    color: #10132e;\n    padding: 0rem 0.5rem;\n  }\n\n  .parts_add_group_textfields {\n    display: flex;\n    align-items: center;\n    gap: 5%;\n    width: 96%;\n    background: #ffffff;\n    border-radius: 6px;\n    background: #ffffff;\n    border-radius: 6px;\n    padding: 0.6rem;\n    flex-wrap: wrap;\n  }\n\n  .parts_add_textfields {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 20px;\n    width: 96%;\n    background: #ffffff;\n    border-radius: 6px;\n    background: #ffffff;\n    border-radius: 6px;\n    padding: 0.6rem;\n    flex-wrap: wrap;\n  }\n\n  .SubmitAddparts:disabled,\n  .SubmitAddparts:disabled:hover {\n    box-shadow: 0px 12px 20px 0px #2A3B894D;\n    font-family: Nunito;\n    font-size: 20px;\n    font-weight: 700;\n    margin: 1rem;\n    padding: 0rem 3rem;\n    border-radius: 8px;\n    width: 14%;\n    height: 2.4rem;\n    color: white;\n    background: #c0cdee !important;\n  }\n\n  .SubmitAddparts {\n    box-shadow: 0px 12px 20px 0px #2A3B894D;\n    font-family: Nunito;\n    font-size: 20px;\n    padding: 0rem 3rem;\n    font-weight: 700;\n    background: #0C3688;\n    color: #ffffff;\n    margin: 1rem;\n    border-radius: 8px;\n    width: fit-content !important;\n    height: 2.4rem;\n  }\n\n  .parts_add_textfieldcontsiners .SubmitAddparts {\n    box-shadow: 0px 12px 20px 0px rgba(42, 59, 137, 0.3019607843);\n    font-family: Nunito;\n    font-size: 20px;\n    font-weight: 700;\n    background: #0C3688;\n    color: #ffffff;\n    margin: 1rem;\n    border-radius: 8px;\n    width: 14%;\n    height: 2.4rem;\n  }\n}\n\n.part_label {\n  top: -7px !important;\n  left: 15px !important;\n}\n\n.multiselect_part {\n  margin-left: 10px !important;\n  width: 100% !important;\n}\n\n.multiselect_part fieldset {\n  border: 1px solid #a3aec4;\n  border-radius: 6px;\n}\n\n.multipleSelect_part {\n  height: 50px;\n  width: 100% !important;\n}\n\n.multiselect_input {\n  min-width: 80% !important;\n}\n\n@media screen and (max-width:480px) {\n  .parts_add_textfieldcontsiners .partlistdropdowndiv_file-addparts {\n    width: 81% !important;\n  }\n\n  label {\n    z-index: 1 !important;\n  }\n\n  .SubmitAddparts {\n    margin-bottom: 20rem !important;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
